<template>
  <v-card
    v-if="legend && legend.length"
    class="legend"
    flat
    tile
  >
    <v-card-title class="pb-0 px-1">
      <h4
        :class="dense ? 'subtitle-1' : 'subheader'"
        style="word-break:normal"
      >
        {{ legendTitle }} :
      </h4>
    </v-card-title>
    <ul>
      <li
        v-for="(item, i) in legend"
        :key="i"
      >
        <span
          :style="`background-color:${item[1]}`"
          class="color-box"
        />{{ (config.colorField && fields[config.colorField] && fields[config.colorField]['x-labels']) ? fields[config.colorField]['x-labels'][item[0]] : item[0] }}
      </li>
    </ul>
  </v-card>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      dense: { type: Boolean, default: false },
    },
    computed: {
      ...mapState(['dataset']),
      ...mapGetters(['config', 'measureTitle', 'legend']),
      legendTitle () {
        if (this.config && this.config.colorField) {
          const field = this.dataset.schema.find(f => f.key === this.config.colorField)
          return field && (field.title || field['x-originalName'] || field.key)
        }
        return ''
      },
      fields () {
        return this.dataset.schema.reduce((a, b) => { a[b.key] = b; return a }, {})
      },
    },
  }
</script>

<style>
.v-card.legend ul {
  list-style-type: none;
  padding-left: 6px;
  margin-top: 0;
  margin-bottom: 2px;
}

.v-card.legend .color-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  position: relative;
  top: 5px;
}
</style>
